import React, { useState } from "react";
import { ReactComponent as DownIcon } from "../assets/svgs/dropdown_icon.svg";
import Button from "../components/atoms/Button";
import ReportsFilter from "../components/molecules/ReportsTransactionsFilter";
import ReportsPlatformFilter from "../components/molecules/ReportsPlatformFilter";
import ReportsTotalFilter from "../components/molecules/ReportsTotalFilter";
import ReportsCountFilter from "../components/molecules/ReportsCountFilter";
import ReportsValueFilter from "../components/molecules/ReportsValueFilter";

const Reports = () => {
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterTotalOpen, setFilterTotalOpen] = useState(false);
  const [filterCountOpen, setFilterCountOpen] = useState(false);
  const [filterValueOpen, setFilterValueOpen] = useState(false);
  const [filterPlatformOpen, setFilterPlatformOpen] = useState(false);

  const handleFilterOpen = () => setFilterOpen(!filterOpen);
  const handleFilterCountOpen = () => setFilterCountOpen(!filterCountOpen);
  const handleFilterValueOpen = () => setFilterValueOpen(!filterValueOpen);
  const handleFilterTotalOpen = () => setFilterTotalOpen(!filterTotalOpen);
  const handleFilterPlatformOpen = () => setFilterPlatformOpen(!filterPlatformOpen);

  return (
    <div className="flex flex-col p-6 pl-6 w-full bg-gray-100" style={{ height: 'calc(100vh - 5rem)', overflowY: 'auto' }}>
      <div className="mt-6">
        <div
          className="w-full bg-white rounded-2xl shadow-md flex justify-between cursor-pointer"
          onClick={handleFilterTotalOpen}
        >
          <h3 className="py-10 px-10 text-xl font-semibold">
            Total Number of Buyers, Seller & Trader
          </h3>
          <Button>
            <DownIcon className="my-auto w-8 h-6 text-[#00000066] opacity-40 mx-5" />
          </Button>
        </div>
        {filterTotalOpen && <ReportsTotalFilter />}
      </div>

      <div className="mt-6">
        <div
          className="w-full bg-white rounded-2xl shadow-md flex justify-between cursor-pointer"
          onClick={handleFilterOpen}
        >
          <h3 className="py-10 px-10 text-xl font-semibold">
            Total Value of Transaction
          </h3>
          <Button>
            <DownIcon className="my-auto w-8 h-6 text-[#00000066] opacity-40 mx-5" />
          </Button>
        </div>
        {filterOpen && <ReportsFilter />}
      </div>

      <div className="mt-6">
        <div
          className="w-full bg-white rounded-2xl shadow-md flex justify-between cursor-pointer"
          onClick={handleFilterCountOpen}
        >
          <h3 className="py-10 px-10 text-xl font-semibold">
            Available Credits (Count) (From Holding)
          </h3>
          <Button>
            <DownIcon className="my-auto w-8 h-6 text-[#00000066] opacity-40 mx-5" />
          </Button>
        </div>
        {filterCountOpen && <ReportsCountFilter />}
      </div>

      <div className="mt-6">
        <div
          className="w-full bg-white rounded-2xl shadow-md flex justify-between cursor-pointer"
          onClick={handleFilterValueOpen}
        >
          <h3 className="py-10 px-10 text-xl font-semibold">
            Available Credits (Valuation) (Only Listed)
          </h3>
          <Button>
            <DownIcon className="my-auto w-8 h-6 text-[#00000066] opacity-40 mx-5" />
          </Button>
        </div>
        {filterValueOpen && <ReportsValueFilter />}
      </div>

      <div className="mt-6">
        <div
          className="w-full bg-white rounded-2xl shadow-md flex justify-between cursor-pointer"
          onClick={handleFilterPlatformOpen}
        >
          <h3 className="py-10 px-10 text-xl font-semibold">
            Platform charges
          </h3>
          <Button>
            <DownIcon className="my-auto w-8 h-6 text-[#00000066] opacity-40 mx-5" />
          </Button>
        </div>
        {filterPlatformOpen && <ReportsPlatformFilter />}
      </div>
    </div>
  );
};

export default Reports;
